import { IField, IFieldOverrides, IFormFieldDefinition } from '../../interfaces/Fields';
import { FormControlBuilder } from './form-control-builder';

export interface IKenticoFormControlToReactFormControlMapping {
  type: string[];
  builder: (field: IField, control: IFormFieldDefinition, formFieldOverrides: IFieldOverrides) => IFormFieldDefinition;
}

export const kenticoFormControlToReactFormControlMap: IKenticoFormControlToReactFormControlMapping[] = [
  {
    type: ['category', 'FormFieldGroup'],
    builder: FormControlBuilder.category
  },
  {
    type: ['TextBoxControl', 'TextAreaControl'],
    builder: FormControlBuilder.text
  },
  {
    type: ['internationalphone'],
    builder: FormControlBuilder.phonenumber
  },
  {
    type: ['NumericInputField'],
    builder: FormControlBuilder.numericinputfield
  },
  {
    type: ['InitialsInputField'],
    builder: FormControlBuilder.intialsinputfield
  },
  {
    type: ['UploadControl'],
    builder: FormControlBuilder.fileupload
  },
  {
    type: ['emailinput', 'email'],
    builder: FormControlBuilder.email
  },
  {
    type: ['EmailAddressList'],
    builder: FormControlBuilder.emailAddressList
  },
  {
    type: ['TextAreaControl'],
    builder: FormControlBuilder.textarea
  },
  {
    type: ['QRCodeScanner'],
    builder: FormControlBuilder.qrcodescanner
  },
  {
    type: ['PasswordControl', 'Password'],
    builder: FormControlBuilder.password
  },
  {
    type: ['LabelControl', 'CalculatedField'],
    builder: FormControlBuilder.readOnly
  },
  {
    type: ['DropDownListControl', 'ListBoxControl'],
    builder: FormControlBuilder.dropdown
  },
  {
    type: ['DropDownListMultipleControl'],
    builder: FormControlBuilder.dropdownMultiple
  },
  {
    type: ['CheckBoxControl', 'ConsentAgreement'],
    builder: FormControlBuilder.checkbox
  },
  {
    type: ['CheckboxMultipleControl'],
    builder: FormControlBuilder.checkboxMultiple
  },
  {
    type: ['RadioButtonsControl', 'RadioButtonAsImageControl'],
    builder: FormControlBuilder.radio
  },
  {
    type: ['CalendarControl'],
    builder: FormControlBuilder.datetime
  },
  {
    type: ['ButtonControl'],
    builder: FormControlBuilder.button
  },
  {
    type: ['PopupConfirm'],
    builder: FormControlBuilder.popupConfirm
  },
  {
    type: ['PopupOK'],
    builder: FormControlBuilder.popupOk
  },
  {
    type: ['LinkField'],
    builder: FormControlBuilder.link
  },
  {
    type: ['GridControl'],
    builder: FormControlBuilder.grid
  },
  {
    type: ['ListControl'],
    builder: FormControlBuilder.list
  },
  {
    type: ['ContributieBlock'],
    builder: FormControlBuilder.contributieBlock
  },
  {
    type: ['TipBlock'],
    builder: FormControlBuilder.tipBlock
  },
  {
    type: ['AlertBlock'],
    builder: FormControlBuilder.alertBlock
  },
  {
    type: ['HtmlAreaControl'],
    builder: FormControlBuilder.richTextEditor
  },
  {
    type: ['RichTextContent'],
    builder: FormControlBuilder.richTextContent
  },
  {
    type: ['CustomTemplate'],
    builder: FormControlBuilder.customTemplate
  },
  {
    type: ['CTABlock'],
    builder: FormControlBuilder.ctaBlock
  },
  {
    type: ['Iban'],
    builder: FormControlBuilder.iban
  },
  {
    type: ['HeadingTwee', 'HeadingDrie'],
    builder: FormControlBuilder.headingTwo
  },
  {
    type: ['ChooseLocation'],
    builder: FormControlBuilder.chooseLocation
  },
  {
    type: ['PetitieTeller'],
    builder: FormControlBuilder.petitieTeller
  }
  ,
  {
    type: ['Switch'],
    builder: FormControlBuilder.switch
  }
  ,
  {
    type: ['HorizontalRuler'],
    builder: FormControlBuilder.horizontalRuler
  },
  {
    type: ['LoginRedirect'],
    builder: FormControlBuilder.loginRedirect,
  },
  {
    type: ['reCaptchaV2Invisible'],
    builder: FormControlBuilder.reCaptcha,
  },
];
